import { Component } from '@angular/core';
import { AdSpaceEnum, AdvertTypeEnum, CreateAdvertModel } from '../../../models/inModels/Advert';
import { Message } from "primeng/components/common/message";
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { Router } from '@angular/router';
import { AdvertService } from '../../../services/business/advert.service';
import { StorageService } from '../../../services/system/storage.service';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { SelectItem } from 'primeng/primeng';

@Component({
	selector: 'app-adverts-create',
	templateUrl: './adverts-create.component.html',
	styleUrls: ['./adverts-create.component.css']
})
export class AdvertsCreateComponent {
	AdSpaceEnum = AdSpaceEnum;
	AdSpaces: any[] = [
		{label: AdSpaceEnum[1], value: 1},
		{label: AdSpaceEnum[2], value: 2},
		{label: AdSpaceEnum[3], value: 3},
		{label: AdSpaceEnum[4], value: 4},
	]; 

	model: CreateAdvertModel;
	loading = false;
	error: Message[];
	uploading = false;
	selectedAdvertType;
	adverts;
	advertTypeId: SelectItem[];

	constructor(
		private auth: AuthenticationService,
		private router: Router,
		private service: AdvertService,
		public storageService: StorageService,
		private confirmationService: ConfirmationService) {
		this.model = new CreateAdvertModel();
		this.model.showInFeed = false;
		this.selectedAdvertType = { value: AdvertTypeEnum.Ads, label: "Adds" };

		console.log(this.model);
	}
	goBack(): void {
		this.router.navigate(['/adverts']);
	}

	save(): void {
		this.loading = true;
		console.log(this.model);
		this.service.create(this.model).then(
			result => {
				this.loading = false;
				this.goBack();
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	handleImage(event): void {
		var result = this.storageService.handleSuccess(event);

		this.model.bannerId = result.PublicId;
		this.loading = false;
	}
	handleVideo(event): void {
		var result = this.storageService.handleSuccess(event);

		this.model.bannerId = result.PublicId;
		this.loading = false;
	}

	handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}

	removeImage(): void {
		this.model.bannerId = null;
		this.loading = false;
	}

	initAdvertTypeDropDown(event): void {
		this.service.getDropdownList(event).then(
			x => {
				this.adverts = x;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setAdvertType(): void {
		this.model.advertTypeId = this.selectedAdvertType.value;
	}

}



// WEBPACK FOOTER //
// ./src/app/components/adverts/adverts-create/adverts-create.component.ts